import { DoBootstrap, NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import * as angular from "angular";
import { environment } from "environments";
import pims from "../../angularJs/src/app/index.module.ajs";

function loadConstantsIntoAngularJS() {
	const ngConstants = angular.module('pims.constants', []);
	Object.entries(environment.constants).forEach(([name, value]) =>
		ngConstants.constant(name, value)
	);
	pims.constant('loggerConfig', {
		enabled: true
	})
}
@NgModule({
	imports: [BrowserModule, UpgradeModule],
})

export class UpgradeAppModule implements DoBootstrap{
	private upgrade = inject(UpgradeModule);


	ngDoBootstrap() {
		loadConstantsIntoAngularJS();
		this.upgrade.bootstrap(document.documentElement, ['pims'], {
			strictDi: true,
		});
	}
}
